// extracted by mini-css-extract-plugin
export default {"question":"Question_question__yM3z9","imageBlock":"Question_imageBlock__mRlk-","image":"Question_image__wr7ON","qBlock":"Question_qBlock__Pn-Bb","answer":"Question_answer__yMW97"};